import {put, putResolve, select, takeLatest} from 'redux-saga/effects';
import {getActivePageId} from '~/stores/player/selectors/course.selectors';
import {setActivePageId} from '../actions/course.actions';
import * as actions from '../actions/undo.actions';

function waitFrame() { 
  return new Promise(resolve => requestAnimationFrame(resolve) || setTimeout(resolve, 0)); 
}

function* reloadPage() {
  const pageId = yield select(getActivePageId);

  if (pageId === -1) {
    return;
  }

  yield putResolve(setActivePageId(-1));
  yield waitFrame();
  yield put(setActivePageId(pageId));
}

export const sagas = [
  takeLatest(actions.UNDO, reloadPage),
  takeLatest(actions.REDO, reloadPage),
];
